(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-faq-leefsamen"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('search');
  if (!searchInput) return;
  
  searchInput.addEventListener('input', function() {
    const searchTerm = this.value.toLowerCase();
    const categories = document.querySelectorAll('.faq-category');
    
    categories.forEach(function(category) {
      let hasVisibleQuestions = false;
      const questions = category.querySelectorAll('[x-data]');
      
      questions.forEach(function(question) {
        const questionText = question.querySelector('button span').textContent.toLowerCase();
        const answerText = question.querySelector('.text-base').textContent.toLowerCase();
        
        if (questionText.includes(searchTerm) || answerText.includes(searchTerm)) {
          question.style.display = 'block';
          hasVisibleQuestions = true;
        } else {
          question.style.display = 'none';
        }
      });
      
      category.style.display = hasVisibleQuestions ? 'block' : 'none';
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-rss-feed"] && !Shopify.designMode) return;
  try {
    
const rssUrl = "https://anchor.fm/s/ffbb0ecc/podcast/rss"; // URL van de RSS-feed

        // Functie om de RSS-feed op te halen en te parseren
        async function fetchRSS() {
            try {
                const response = await fetch(rssUrl);
                const text = await response.text();

                // Parse de RSS XML
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(text, "application/xml");

                // Haal alle items uit de RSS-feed
                const items = xmlDoc.querySelectorAll("item");
                const feedContainer = document.getElementById("rssFeed");

                items.forEach(item => {
                    const title = item.querySelector("title").textContent;
                    const link = item.querySelector("link").textContent;
                    const description = item.querySelector("description").textContent;
                    const pubDate = item.querySelector("pubDate").textContent;

                    // Haal afbeelding uit de itunes:image tag
                    let image = item.querySelector("itunes\\:image, image");
                    if (image) {
                        image = image.getAttribute("href");
                    } else {
                        image = 'https://via.placeholder.com/90'; // Placeholder voor als er geen afbeelding is
                    }

                    // Haal de audiobestanden uit de enclosure tag
                    const audioUrl = item.querySelector("enclosure") ? item.querySelector("enclosure").getAttribute("url") : '';

                    // Maak een nieuw element voor elk RSS-item
                    const rssItem = document.createElement("div");
                    rssItem.className = "flex flex-col md:flex-row items-center border-b border-gray-200 py-5 transition-colors duration-300";

                    rssItem.innerHTML = `
                        <a href="${link}" target="_blank" rel="noopener noreferrer" class="flex flex-col md:flex-row w-full text-gray-800 no-underline">
                            <img src="${image}" alt="Podcast Afbeelding" class="w-[90px] h-[90px] rounded-xl mx-auto md:mx-0 md:mr-5 mb-4 md:mb-0">
                            <div class="w-full text-center md:text-left">
                                <h3 class="text-xl md:text-2xl font-bold m-0">${title}</h3>
                                <p class="text-base text-gray-600 my-2">${description.substring(0, 120)}...</p>
                                <p class="text-sm text-gray-400">Geplaatst op: ${new Date(pubDate).toLocaleString()}</p>
                            </div>
                        </a>
                        <div class="w-full mt-4 md:pl-4">
                            ${audioUrl ? `<audio controls class="w-full">
                                <source src="${audioUrl}" type="audio/mpeg">
                                Your browser does not support the audio element.
                            </audio>` : ''}
                        </div>
                    `;

                    // Voeg het item toe aan de container
                    feedContainer.appendChild(rssItem);
                });
            } catch (error) {
                console.error("Fout bij het ophalen van de RSS-feed:", error);
            }
        }

        // Roep de functie aan om de RSS-feed op te halen en weer te geven
        fetchRSS();

  } catch(e) { console.error(e); }
})();
})();
